import base from './base'

export default {
    ...base,
    title: {
        type: ['undefined', 'string']
    },
    publish_date: {
        type: ['undefined', 'string']
    },
    name: {
        type: ['undefined', 'string']
    },
    description: {
        type: ['undefined', 'string']
    },
    synopsis: {
        type: ['undefined', 'string']
    },
    total_views_count: {
        type: ['undefined', 'number']
    },
    total_likes_count: {
        type: ['undefined', 'number']
    },
    background_color: {
        type: ['undefined', 'string']
    },
    genders: {
        type: ['array'],
        default: () => []
    },
    min_age: {
        type: ['undefined', 'number']
    },
    max_age: {
        type: ['undefined', 'number']
    },
    duration: {
        type: ['undefined', 'string']
    },
    file: {
        type: ['array'],
        default: () => []
    },
    gallery: {
        type: ['array'],
        default: () => []
    },
    videos: {
        type: ['array'],
        default: () => []
    },
    media: {
        type: ['array'],
        default: () => []
    },
    banner: {
        type: ['object'],
        default: () => {}
    },
    comments: {
        type: ['array'],
        default: () => []
    },
    category_ids: {
        type: ['array'],
        default: () => []
    },
    author_ids: {
        type: ['array'],
        default: () => []
    },
    illustrator_ids: {
        type: ['array'],
        default: () => []
    },
    narrator_ids: {
        type: ['array'],
        default: () => []
    },
    character_ids: {
        type: ['array'],
        default: () => []
    },
    authors: {
        type: ['array'],
        default: () => []
    },
    narrators: {
        type: ['array'],
        default: () => []
    },
    illustrators: {
        type: ['array'],
        default: () => []
    },
    characters: {
        type: ['array'],
        default: () => []
    },
    for_days: {
        type: ['array'],
        default: () => []
    },
    shares: {
        type: ['array'],
        default: () => []
    },
    is_special: {
        type: ['boolean'],
        default: false
    },
    premium_required: {
        type: ['boolean'],
        default: false
    },
}